import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ButtonProps, StyledResetButton } from '~/shared/components';
import { cover } from '~/shared/utils/styled';
import { breakpoints } from '~/theme';

export const StyledDrawerContainer = styled.div(({ theme }) => ({
    position: 'fixed',
    zIndex: theme.zIndices.max,
    display: 'block',
    [breakpoints.md]: {
        zIndex: theme.zIndices['drawer'],
    },
}));

export const StyledDrawerContent = styled.div<{ isOpen: boolean; top: number }>(
    ({ theme, isOpen, top }) => ({
        width: '100%',
        borderLeft: 'none',
        borderTop: theme.borders.border,
        ...cover,
        position: 'fixed',
        backgroundColor: theme.colors.light,
        animationDuration: theme.animations.getDuration('moderate02'),
        animationTimingFunction: theme.animations.getEasing('standard', 'productive'),
        animationFillMode: 'both',
        animationName: keyframes({
            from: { transform: `translate3d(0, ${isOpen ? '100%' : '0'},0)` },
            to: { transform: `translate3d(0, ${isOpen ? '0' : '100%'},0)` },
        }),
        [breakpoints.md]: {
            width: `${theme.sizes.desktopFilterDrawerWidth}px`,
            inset: `${top}px 0 0 auto`,
            borderLeft: `1px solid ${theme.colors.dark}`,
            borderTop: 'none',
            animationName: keyframes({
                from: { transform: `translate3d(${isOpen ? '100%' : '0'},0,0)` },
                to: { transform: `translate3d(${isOpen ? '0' : '100%'},0,0)` },
            }),
        },
    })
);

export const StyledCloseButton = styled(StyledResetButton)<ButtonProps>(({ theme }) => ({
    fontSize: theme.fontSizes.xl,
}));

export const StyleAccordionContent = styled.div<{ top: number }>(({ theme, top }) => ({
    overflowY: 'scroll',
    paddingBottom: theme.spaces[10],
    maxHeight: [
        `calc(100vh - ${theme.spaces[5]} - ${theme.spaces[7]})`,
        `calc(100dvh - ${theme.spaces[5]} - ${theme.spaces[7]})`,
    ],
    [breakpoints.md]: {
        maxHeight: [`calc(100vh - ${top}px)`, `calc(100dvh - ${top}px)`],
    },
}));

export const StyledResponsiveActionButtons = styled.div(({ theme }) => ({
    display: 'flex',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    borderTop: theme.borders.border,
    padding: `${theme.spaces[3]} 0 ${theme.spaces[6]}`,
    backgroundColor: theme.colors.light,
    zIndex: theme.zIndices[1],
    ['button']: {
        flex: 1,
        margin: `0 ${theme.spaces[2]}`,
        paddingLeft: '0',
        paddingRight: '0',
    },
    [breakpoints.md]: {
        display: 'none',
    },
}));
